import { render, staticRenderFns } from "./SettingDynamicPricing.vue?vue&type=template&id=3fd29084&scoped=true"
import script from "./SettingDynamicPricing.vue?vue&type=script&lang=js"
export * from "./SettingDynamicPricing.vue?vue&type=script&lang=js"
import style0 from "./SettingDynamicPricing.vue?vue&type=style&index=0&id=3fd29084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd29084",
  null
  
)

export default component.exports